/**
 * @file Matrix转换基座
 * @author shengzhao
 */

var Sylvester = function Sylvester() {};
Sylvester.Matrix = function () {};
Sylvester.Matrix.create = function (elements) {
  var M = new Sylvester.Matrix();
  return M.setElements(elements);
};
export var $M = Sylvester.Matrix.create;
Sylvester.Matrix.prototype.setElements = function (els) {
  var i,
    j,
    elements = els.elements || els;
  if (elements[0] && typeof elements[0][0] !== 'undefined') {
    i = elements.length;
    this.elements = [];
    while (i--) {
      j = elements[i].length;
      this.elements[i] = [];
      while (j--) {
        this.elements[i][j] = elements[i][j];
      }
    }
    return this;
  }
  var n = elements.length;
  this.elements = [];
  for (i = 0; i < n; i++) {
    this.elements.push([elements[i]]);
  }
  return this;
};
Sylvester.Matrix.prototype.multiply = function (matrix) {
  if (this.elements.length === 0) {
    return null;
  }
  if (!matrix.elements) {
    return this.map(function (x) {
      return x * matrix;
    });
  }
  var returnVector = matrix.modulus ? true : false;
  var M = matrix.elements || matrix;
  if (typeof M[0][0] === 'undefined') {
    M = Sylvester.Matrix.create(M).elements;
  }
  if (!this.canMultiplyFromLeft(M)) {
    return null;
  }
  var i = this.elements.length,
    nj = M[0].length,
    j;
  var cols = this.elements[0].length,
    c,
    elements = [],
    sum;
  while (i--) {
    j = nj;
    elements[i] = [];
    while (j--) {
      c = cols;
      sum = 0;
      while (c--) {
        sum += this.elements[i][c] * M[c][j];
      }
      elements[i][j] = sum;
    }
  }
  var M = Sylvester.Matrix.create(elements);
  return returnVector ? M.col(1) : M;
};
Sylvester.Matrix.prototype.canMultiplyFromLeft = function (matrix) {
  if (this.elements.length === 0) {
    return false;
  }
  var M = matrix.elements || matrix;
  if (typeof M[0][0] === 'undefined') {
    M = Sylvester.Matrix.create(M).elements;
  }
  // this.columns should equal matrix.rows
  return this.elements[0].length === M.length;
};
Sylvester.Matrix.prototype.x = Sylvester.Matrix.prototype.multiply;